<template>
  <div id="requestAcct">
    <div class="container">
      <h1>Request Account</h1>
      <div class="ui floating negative message" v-if="error">
        <i class="close icon" @click="close()"></i>
        <div class="header">We're sorry but an error occurred</div>
        <p>{{ error }}</p>
      </div>
      <form id="RequestAcct" class="row" @submit.prevent="registration">
        <div class="col-lg-6 pr-lg-0 mb-4 mb-lg-0">
          <div class="ra-left">
            <div class="form-row">
              <div class="col-lg-6 mb-4 mb-lg-0">
                <label for="firstName">First Name</label>
                <input
                  v-model="firstName"
                  type="text"
                  id="firstName"
                  placeholder="First Name"
                  required
                />
              </div>
              <div class="col-lg-6">
                <label for="lastName">Last Name</label>
                <input
                  v-model="lastName"
                  type="text"
                  id="lastName"
                  placeholder="Last Name"
                  required
                />
              </div>
            </div>
            <div class="form-row">
              <label for="Phone">Contact Phone Number</label>
              <input
                v-model="Phone"
                type="tel"
                id="Phone"
                placeholder="Phone Number"
                required
                autofocus
              />
            </div>
            <div class="form-row">
              <label for="companyName">Company Name</label>
              <input
                v-model="companyName"
                type="text"
                id="companyName"
                placeholder="Company Name"
                required
                autofocus
              />
            </div>
            <div class="form-row">
              <label for="address1">Ship To Address</label>
              <input
                v-model="address1"
                type="text"
                id="address1"
                placeholder="Address 1"
                required
              />
            </div>
            <div class="form-row">
              <label for="address2">Ship To Address Line 2</label>
              <input
                v-model="address2"
                type="text"
                id="address2"
                placeholder="Address 2"
              />
            </div>
            <div class="form-row">
              <div class="col-lg-6 mb-4 mb-lg-0">
                <label for="city">City</label>
                <input
                  v-model="city"
                  type="text"
                  id="city"
                  placeholder="City"
                  required
                />
              </div>
              <div class="col-lg-6">
                <label for="State">State</label>
                <div class="ui fluid search selection dropdown">
                  <input
                    type="hidden"
                    name="state"
                    v-model="state"
                    id="state"
                    @change="onStateChange"
                  />
                  <div class="default text">Select State</div>
                  <i class="dropdown icon"></i>
                  <div class="menu">
                    <div
                      class="item"
                      v-for="state in states"
                      :key="state.value"
                      v-bind:data-value="state.value"
                    >
                      {{ state.text }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-lg-6 mb-4 mb-lg-0">
                <label for="postalCode">Postal Code</label>
                <input
                  v-model="postalCode"
                  type="text"
                  id="postalCode"
                  placeholder="Postal Code"
                  required
                />
              </div>
              <div class="col-lg-6">
                <label for="Country">Country</label>
                <div
                  id="countrySelect"
                  class="ui fluid search selection dropdown"
                >
                  <input
                    type="hidden"
                    name="country"
                    v-model="country"
                    id="country"
                    @change="onCountryChange"
                  />
                  <div class="default text">Select Country</div>
                  <i class="dropdown icon"></i>
                  <div class="menu">
                    <div
                      class="item"
                      v-for="country in countries"
                      :key="country.value"
                      v-bind:data-value="country.value"
                    >
                      <i :class="country.flag" class="flag"></i>
                      {{ country.text }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 pl-lg-0">
          <div class="ra-right">
            <div class="form-row">
              <div class="form-content">
                <h2>More Information</h2>
                <ul>
                  <li>
                    Enter JC Steele Customer ID (e.g., NC100) and click Submit
                    <i
                      >If you don’t know your Customer ID, contact your JC
                      Steele representative</i
                    >
                  </li>
                  <li>Enter registration information and click Submit</li>
                  <li>
                    Upon approval of your registration, you will receive a
                    <strong>Welcome to SteeleService</strong> email
                  </li>
                  <li>
                    Login to <strong>SteeleService</strong> using your Customer
                    ID and Password you chose when you registered
                  </li>
                  <li>All information is case sensitive</li>
                </ul>
                <div class="have-question">
                  Have a question? Give us a call
                  <a :href="'tel:' + companyPhone" class="hq-phone">{{
                    companyPhone
                  }}</a>
                </div>
              </div>
            </div>

            <div class="form-row">
              <label for="customerID">Customer ID</label>
              <input
                v-model="customerID"
                type="text"
                id="customerID"
                placeholder="Customer ID"
                required
                autofocus
              />
            </div>
            <div class="form-row">
              <label for="email">Email Address</label>
              <input
                v-model="email"
                type="email"
                id="email"
                placeholder="email@gmail.com"
                required
              />
            </div>
            <div class="form-row">
              <label for="inputPassword">Password</label>
              <input
                v-model="password"
                type="password"
                id="inputPassword"
                placeholder="Password"
                required
              />
            </div>
            <div class="form-row">
              <label for="inputConfirmPassword">Retype Password</label>
              <input
                v-model="confirmPassword"
                type="password"
                id="inputConfirmPassword"
                placeholder="Retype Password"
                required
              />
            </div>
            <div class="row align-items-center">
              <button
                class="ui btn-primary col-sm-5 mb-4 mb-sm-0"
                type="submit"
              >
                Request Account
              </button>
              <a
                href="/login"
                class="forgot-pw col-sm-5 offset-sm-2 text-sm-right"
                >Return To Login Screen</a
              >
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import $ from "jquery";
import "expose-loader?$!expose-loader?jQuery!jquery";
import "semantic-ui-dropdown/dropdown.js";

export default {
  name: "Registration",
  data() {
    return {
      companyName: "",
      customerID: "",
      userID: "",
      username: "",
      password: "",
      confirmPassword: "",
      firstName: "",
      lastName: "",
      email: "",
      address1: "",
      address2: "",
      city: "",
      postalCode: "",
      error: false,
      state: "",
      country: "",
      states: [],
      countries: [],
      current: null,
      Phone: "",
      companyPhone: ""
    };
  },
  mounted() {
    this.getCountries();
    this.getStates();
    this.setCountry();
    this.settingsDetails();

    Vue.filter("companyPhone", function(companyPhone) {
      return companyPhone
        .replace(/[^0-9]/g, "")
        .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
    });
  },
  methods: {
    onStateChange(event) {
      this.state = event.target.value;
    },
    onCountryChange(event) {
      this.country = event.target.value;
    },
    close() {
      $(".ui.message").transition("fade");
      this.error = false;
    },
    registration() {
      apiService
        .register({
          companyName: this.companyName,
          customerID: this.customerID,
          username: this.username,
          password: this.password,
          PasswordConfirmation: this.confirmPassword,
          firstName: this.firstName,
          lastName: this.lastName,
          Phone: this.Phone,
          email: this.email,
          address1: this.address1,
          address2: this.address2,
          city: this.city,
          postalCode: this.postalCode,
          state: this.state,
          country: this.country,
          error: false,
        })
        .then((request) => this.registrationSuccessful(request))
        .catch((request) => this.registerFailed(request));
    },
    registrationSuccessful(request) {
      this.error = false;
      this.$router.push({
        name: "RegistrationSuccess",
        params: {
          success: true,
          data: request,
        },
      });
    },
    registerFailed(request) {
      this.error = request.error.response.data;
      this.$store.dispatch("logout");
      delete localStorage.token;
      if (request.error.response.data.traceId || "" != "") {
        this.$bvToast.toast("TraceID: " + request.error.response.data.traceId, {
          title: request.error.response.data.title,
          autoHideDelay: 10000,
          appendToast: false,
          variant: "danger",
          solid: true,
        });
      }
    },
    getStates() {
      var states = [];
      apiService.getStatesByCountry("US").then((data) => {
        for (var i = 0; i < data.length; i++) {
          var state = {
            key: data[i].code,
            value: data[i].code,
            flag: data[i].code.toLowerCase(),
            text: data[i].name,
          };
          states.push(state);
        }
        this.states = states;
      });
    },
    getCountries() {
      var countries = [];
      apiService.getCountries().then((data) => {
        for (var i = 0; i < data.length; i++) {
          var country = {
            key: data[i].code,
            value: data[i].code,
            flag: data[i].code.toLowerCase(),
            text: data[i].name,
          };
          countries.push(country);
        }
        this.countries = countries;
      });

      this.country = "US";
    },
    setCountry() {
      setTimeout(function() {
        $("#countrySelect").dropdown("set selected", this.country);
        $(".ui.dropdown").dropdown({fullTextSearch:true});
      }, 1000);
    },
    settingsDetails() {
      apiService
        .getCompanySettings()
        .then((request) => {
          this.settingsSuccessful(request);
        })
        .catch((err) => this.settingsFailed(err));
    },
    settingsSuccessful(request) {
      this.companyPhone = request.companyPhone;
    },
    settingsFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
  },
};
</script>
